import React, { useEffect, useState } from "react";
import ArchivedCasesTable from "../Tables/archivedCasesTables";
import { getProgramById } from "../../services/getProgramService";
import { getAgencyById } from "../../services/getAgencyService";
import { getCasesByProgramId } from "../../services/casesService";
import { Paper, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";
import authService from "../../services/authService";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const ArchivedCases = () => {
  const ProgramId = sessionStorage.getItem("ProgramId");
  const pfyId = sessionStorage.getItem("ProgramByFiscalYearId");
  const fiscalYear = useSelector((state) => state.fiscalYear.current);
  const user = authService.getCurrentUser();
  const Role = user.role;
  const [program, setProgram] = useState(null);
  const [agency, setAgency] = useState(null);
  const [cases, setCases] = useState([]);

  useEffect(() => {
    if (!ProgramId || !fiscalYear) return; // Prevent API calls if ProgramId or fiscalYear is missing

    const fetchData = async () => {
      try {
        const { data: programData } = await getProgramById(ProgramId);
        setProgram(programData);

        if (programData.agencyId) {
          const { data: agencyData } = await getAgencyById(
            programData.agencyId
          );
          setAgency(agencyData);
        }

        const { data: allCases } = await getCasesByProgramId(ProgramId);

        const filteredCases = allCases.filter((caseItem) => {
          if (caseItem.status !== "Archived") return false;

          if (Role === "Provider") {
            const dateOfExit = new Date(caseItem.dateOfExit);
            const startDate = new Date(fiscalYear.startDate);
            const endDate = new Date(fiscalYear.endDate);

            return dateOfExit >= startDate && dateOfExit <= endDate;
          }

          return true;
        });

        setCases(filteredCases);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [pfyId, ProgramId, fiscalYear]);

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} className="mt-3">
          <Item>
            <h1 className="mb-5 text-center">Archived Cases</h1>

            <div className="row">
              <div className="row">
                <div className="col-6 fw-bold">Agency:</div>
                <div className="col-6 text-start">{agency?.name || "N/A"}</div>
              </div>
              <div className="row">
                <div className="col-6 fw-bold">Program:</div>
                <div className="col-6 text-start">{program?.name || "N/A"}</div>
              </div>
              <div className="row">
                <div className="col-6 fw-bold">Program ID:</div>
                <div className="col-6 text-start">{ProgramId || "N/A"}</div>
              </div>
              <div className="row">
                <div className="col-6 fw-bold">Number of Archived Cases:</div>
                <div className="col-6 text-start">{cases.length}</div>
              </div>
            </div>
          </Item>
        </Grid>
      </Grid>

      <div className="mt-4">
        {cases.length > 0 ? (
          <ArchivedCasesTable cases={cases} />
        ) : (
          <div className="text-center mt-3">
            <h5>No archived cases available</h5>
          </div>
        )}
      </div>
    </>
  );
};

export default ArchivedCases;
